/**
 * forEach allows us to iterate over NodeLists in a fast browser compatible way.
 *
 * @export
 * @param {any} array
 * @param {any} callback
 * @param {any} scope
 */
export default function forEach (array, callback, scope) {
    let i = 0
    for (i; i < array.length; i++) {
        callback.call(scope, array[i], i)
    }
}
